const imagesPath = {
    "destopView": require('../images/banner-01.webp'),
    "mobileView": require('../images/banner-mobile.webp'),
    "img1": require("../assets/img/career-page-banner.webp"),
    "img2": require("../assets/img/auto.webp"),
    "img3": require("../assets/img/bike.webp"),
    "img4": require("../assets/img/more-btn.webp"),
    "img7": require("../assets/img/about-us.webp"),
    "img8": require("../assets/img/blog-14.webp"),
    "img9": require("../assets/img/blog-11.webp"),
    "img10": require("../assets/img/blog-13.webp"),
    "img11": require("../assets/img/blog-12.webp"),
    "img12": require("../assets/img/blog5.webp"),
    "img13": require("../assets/img/blog6.webp"),
    "img14": require("../assets/img/blog7.webp"),
    "img15": require("../assets/img/blog8.webp"),
    "img16": require("../assets/img/blog-15.webp"),
    "img18": require("../assets/img/team/Mehul.webp"),
    "img19": require("../assets/img/team/Ranjit.webp"),
    "img20": require("../assets/img/team/Abhishek.webp"),
    "img21": require("../assets/img/team/Aashish.webp"),
    "img22": require("../assets/img/team/Shantanu.webp"),
    "img23": require("../assets/img/team/Payal.webp"),
    "img24": require("../assets/img/team/Sameer.webp"),
    "img25": require("../assets/img/app-store.webp"),
    "img26": require("../assets/img/get-strat-btn.webp"),
    "img27": require("../assets/img/google-play.webp"),
    "img28": require('../assets/img/greatPlaceToWork.webp'),
    "img29": require('../assets/img/team/monika.webp'),
    "img30": require('../assets/img/team/ishita.png'),
    "img32": require('../assets/img/team/deepa.png'),
    "img33": require('../assets/img/21_Sept_2022_National_CSR_Leadership_Award.webp'),
    "img34": require('../assets/img/26_Aug_2022_ET_Leadership_ecellence_Awards.webp'),
    "img35": require('../assets/img/30_July_2022_EV_state_leadership_Delhi_Award.webp'),
    "img36": require("../assets/img/team/Sushil.webp"),
    "img37": require("../assets/img/IF50_news_18-10-2022.webp"),
    "img38": require("../assets/img/Revfin-SeriesA-funding.webp"),
    "img39": require('../assets/img/team/nikhil.webp'),
    "img40": require('../assets/img/nbfc-award-02-12-22.webp'),
    "img41": require('../assets/img/ifta-awards-02-12-22.webp'),
    "img42": require('../assets/img/EV-awards.webp'),
    "img43": require('../assets/img/IFTA-12-22.webp'),
    "img44": require('../assets/img/great-place-to-work-2024-25.webp'),
    "img45": require('../assets/img/BFSI-FE-championship-Fintech-Summit-2023.webp'),
    "img46": require('../assets/img/Best-Sustainability-Initiative-Fintech-Award-2023.webp'),
    "img47": require('../assets/img/Elets-2nd-NBFC100-Leade-Excellence-Awards.webp'),
    "img48": require('../assets/img/afi.png'),
    "img49": require('../assets/img/stree-shakti.JPG'),
    "img50": require('../assets/img/solar.webp'),
    "img51": require('../assets/img/sun-mobility.jpg'),
    "img52": require('../assets/img/bestPlacetowork.webp'),
    "img53": require('../assets/img/auto_tech_giants.webp'),
    "img54": require('../assets/img/best_place_to_work.webp'),
    "img55": require('../assets/img/sustainable_mobility_revolution.webp'),
    "img56": require('../assets/img/ev_financing_start_up.webp'),
    "img57": require('../assets/img/media_brief_best_place_to_work.webp'),
    "img58": require('../assets/img/anticipating_ev_vehicles_era.webp'),
    "img59": require('../assets/img/ev_financing.webp'),
    "img60": require('../assets/img/jagriti_yatra.webp'),
    "img61": require('../assets/img/revfin_with_kptl.webp'),
    "img62": require('../assets/img/bajaj_auto_partner.webp'),
    "img63": require('../assets/img/sameer_jagruti_yatra.webp'),

    "gridImages": [
        {
            "img": require("../assets/img/events/Life @revfin5.webp")
        },
        {
            "img": require("../assets/img/events/Life @revfin2.webp")
        },
        {
            "img": require("../assets/img/events/Life @revfin3.webp")
        },
        {
            "img": require("../assets/img/events/Life @revfin4.webp")
        },
        {
            "img": require("../assets/img/events/Life @revfin1.webp")
        },
    ],
    "bannerImage":
        [
            {
                "img": require("../assets/img/banner-1.webp")
            },
            {
                "img": require("../assets/img/banner-2.webp")
            },
        ],
    "partnerLogo": [
        {
            "img": require("../assets/img/Caspian Debt.webp"),
        },
        {
            "img": require("../assets/img/Hero-Electric.webp"),
        },
        {
            "img": require("../assets/img/uber-logo.webp"),
        },
        {
            "img": require("../assets/img/Northern-Arc.webp"),
        },
        {
            "img": require("../assets/img/Kinetic-Green.webp"),
        }
    ],

    "memberCertificate": [
        {
            "img": require("../assets/img/fintech.webp")
        },
        {
            "img": require("../assets/img/nbfc.webp")
        },
        {
            "img": require("../assets/img/certin.webp")
        },
        {
            "img": require("../assets/img/sis.webp")
        },
        {
            "img": require("../assets/img/digita-lender-award.jpg")
        },
        {
            "img": require("../assets/img/Awards_ET_ascent_smart_cities_leadership_award.webp")
        },
        {
            "img": require("../assets/img/ET_Leadership_excellence_Award.webp")
        },
        {
            "img": require("../assets/img/ET_state_leadership_award.webp")
        },
        {
            "img": require("../assets/img/IF50.webp")
        },
        {
            "img": require("../assets/img/ifta-awards-02-12-22.webp")
        },
        {
            "img": require("../assets/img/nbfc-award-02-12-22.webp")
        },
        {
            "img": require('../assets/img/EV-awards.webp')
        },
        {
            "img": require('../assets/img/IFTA-12-22.webp'),
        },
        {
            "img": require('../assets/img/great-place-to-work-2024-25.webp'),
        },
        {
            "img": require('../assets/img/Best-Sustainability-Initiative-Fintech-Award-2023.webp'),
        },
        {
            "img": require('../assets/img/BFSI-FE-championship-Fintech-Summit-2023.webp'),
        },
        {
            "img": require('../assets/img/Elets-2nd-NBFC100-Leade-Excellence-Awards.webp'),
        },
        {
            "img": require('../assets/img/Best-Mobile-App-Initiative-at-NBFC-Awards.jpeg'),
        },
        {
            "img": require('../assets/img/Forbes-DGEMS-2023.jpg'),
        },
        {
            "img": require('../assets/img/EV-Financier-of-the-Year-2023.jpg'),
        },
        {
            "img": require('../assets/img/Atal-Achievement-Award.jpg'),
        },
        {
            "img": require('../assets/img/Meaningful-Business-2023.jpg'),
        },
        {
            "img": require('../assets/img/ashish.webp'),
        },
        {
            "img": require('../assets/img/E_Mobility_Payal.webp'),
        },
        {
            "img": require('../assets/img/sameer_finext.webp'),
        },
        {
            "img": require('../assets/img/finext.webp'),
        },
        {
            "img": require('../assets/img/E_Mobility.webp'),
        },
        {
            "img": require('../assets/img/optimizer_Atal_Achievement_Award.webp'),
        },
        {
            "img": require('../assets/img/2023_Best_Fintech_Initiative.webp'),
        },
        {
            "img": require('../assets/img/big_impact_winner.webp'),
        },
        {
            "img": require('../assets/img/sameer_gift_brand_story.webp'),
        },
        {
            "img": require('../assets/img/iconic_brand.webp'),
        },
        {
            "img": require('../assets/img/shoonya_gift.webp'),
        },
        {
            "img": require('../assets/img/bw_fintech_award_2024.webp'),
        },
    ],

    // youtube video

    "video1": "https://www.youtube.com/embed/uFgNysCcKfs?rel=0&loop=1&controls=0",
    "video2": "https://www.youtube.com/embed/NX3kVdMZP04?rel=0&loop=1&controls=0",
    "video3": "https://www.youtube.com/embed/uFgNysCcKfs?rel=0&loop=1&controls=0",
    "video4": "https://www.youtube.com/embed/5RR0N96fwZ8?rel=0&loop=1&controls=0",
    "video5": "https://www.youtube.com/embed/5RR0N96fwZ8?rel=0&loop=1&controls=0",
    "video6": "https://www.youtube.com/embed/CIR0m2ucLQE?rel=0&loop=1&controls=0",
    "video7": "https://www.youtube.com/embed/CTxrv0uWfmk?rel=0&loop=1&controls=0",
    "video8": "https://www.youtube.com/embed/l-Tet3th5O4?rel=0&loop=1&controls=0",
    "video9": "https://www.youtube.com/embed/hwI9XLu7gqY?rel=0&loop=1&controls=0",
    "video10": "https://www.youtube.com/embed/5eAvKMnZaP4?rel=0&loop=1&controls=0",

    "testmonialVideo": [
        {
            video1: "https://www.youtube.com/embed/8HawTyKe9po?rel=0&loop=1&controls=0",
            video2: "https://www.youtube.com/embed/CIR0m2ucLQE?rel=0&loop=1&controls=0",

        },
        {

            video1: "https://www.youtube.com/embed/5kM9uK65BU4?rel=0&loop=1&controls=0",
            video2: "https://www.youtube.com/embed/w776XCbrsNg?rel=0&loop=1&controls=0",


        },
        {

            video1: "https://www.youtube.com/embed/18ZfVGCqZsQ?rel=0&loop=1&controls=0",
            video2: "https://www.youtube.com/embed/mi_8fKLQPZM?rel=0&loop=1&controls=0",

        },
        {

            video1: "https://www.youtube.com/embed/t2FLYH5gYtg?rel=0&loop=1&controls=0",

        }
    ],
    "team_talk": [
        {
            video: "https://www.youtube.com/embed/2aQ6bot681c?rel=0&loop=1&controls=0"
        },
        {
            video: "https://www.youtube.com/embed/UouE8a0YZPc?rel=0&loop=1&controls=0",
        },
        {
            video: "https://www.youtube.com/embed/xQ3RdM9O07o?rel=0&loop=1&controls=0",
        },
        {
            video: "https://www.youtube.com/embed/7PNbhYc--b4?rel=0&loop=1&controls=0"
        },
        {
            video: "https://www.youtube.com/embed/YyaOg02lDhY?rel=0&loop=1&controls=0",
        },
        {
            video: "https://www.youtube.com/embed/g47hVNWjSB0?rel=0&loop=1&controls=0",
        },
    ],
}

export default imagesPath



// WEBPACK FOOTER //
// ./src/config/imagesPath.js